import { updateConditionOptionImageIdAction as updateConditionOptionImageIdOperation } from 'editor/src/store/design/slice';

export default updateConditionOptionImageIdOperation;
